<template>
  <q-btn
    align="between"
    class="app-bar-filter-slot-mobile"
    color="util-2"
    icon-right="arrow_drop_down"
    no-caps
    :ripple="false"
    text-color="secondary"
    unelevated
  >
    <div class="btn-label">
      <div
        class="btn-label__title"
        v-text="title"
      />

      <div
        class="btn-label__subtitle"
        v-text="subtitle"
      />
    </div>

    <q-menu
      v-model="menu"
      class="filters__menu"
      fit
      square
      transition-hide="slide-up"
      transition-show="slide-down"
      @before-hide="layoutOverlay = false"
      @before-show="layoutOverlay = true"
    >
      <SPFilter
        v-for="filter in filtersLocal"
        :key="filter.slug"
        v-bind="filter"
        v-model="filterValues[filter.slug]"
        expansion
      />
    </q-menu>
  </q-btn>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, onBeforeUnmount, ref } from 'vue'

import SPFilter from '@/components/SearchPage/Filters/SPFilter.vue'
import { useFilter } from '@/composables/filter/index'
import { useTheme } from '@/composables/theme'
import { useAppStore } from '@/store/modules/app'
import { useThemeStore } from '@/store/modules/theme'

const { responseListingsMeta } = storeToRefs(useAppStore())

const { layoutOverlay } = storeToRefs(useThemeStore())

const { breakpoint } = useTheme()

const slot = computed(() => 'navbar-top-middle')

const { filtersLocal, filterValues } = useFilter(breakpoint, slot)

const menu = ref<boolean>(false)

const title = computed<string>(() => responseListingsMeta.value?.title ?? '')

const subtitle = computed<string>(() => {
  const metaLocations = responseListingsMeta.value?.locations

  if (!metaLocations?.length) {
    return ''
  }

  const _subtitle: string[] = [metaLocations[0].label]

  if (metaLocations.length > 1) {
    _subtitle.push(`+${metaLocations.length - 1}`)
  }

  return _subtitle.join(' ')
})

onBeforeUnmount(() => {
  layoutOverlay.value = false
})
</script>

<style lang="scss">
.app-bar-filter-slot-mobile {
  z-index: 9999;
  width: 100%;
  min-height: 48px;

  .btn-label {
    flex: 1 1 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    overflow: hidden;
    color: $secondary;
    text-align: left;
  }

  .btn-label__title {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.25rem;
    white-space: nowrap;
  }

  .btn-label__subtitle {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1rem;
    white-space: nowrap;
  }
}

.filters__menu {
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
  overflow: visible;
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  &:before {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: -1;
    width: calc(100vw + 2px);
    height: 100%;
    content: '';
    background: white;
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
    transform: translateX(-50%);
  }
}
</style>
